import { css } from '@huspy/styled-system/css';

export const rateInvidualCard = {
  header: css({
    width: '100%',
    borderTopRadius: 'radius-4',
    backgroundColor: 'utility-blue-400',
    paddingX: 4,
    paddingY: 2,
  }),
  content: css({
    width: '100%',
    borderBottomRadius: 'radius-4',
    border: '1px solid',
    borderColor: 'border-secondary',
    backgroundColor: 'bg-secondary',
    padding: 3,
    gap: 5,
    textAlign: 'center',
  }),
};
